import { authService } from "../service";
import { setRegisterError, setresgisterLoading } from "../slice/registerSlice";
import { setloginData, setloginError,setCompany } from "../slice/loginSlice";
import { setParticipantLoginData, setParticipantLoginError, } from "../slice/participantLoginSlice";

const adminRegistrationAsync =
  (registerData, companyId, navigate, workshop_uuid,is_project=false) => async (dispatch) => {
    dispatch(setresgisterLoading(true));
    try {
      const response = await authService.adminRegistration(
        registerData,
        companyId,
        workshop_uuid,
        is_project
      );
      if (response.error || response.Error) {
        dispatch(setresgisterLoading(false));
        dispatch(setRegisterError(response.error));
      } else {
        dispatch(setresgisterLoading(false));
        if (response[0] === "Success: True")
          navigate(`/companies/${companyId}/workshops/${workshop_uuid}/admins/register-success`);
      }
    } catch (error) {
      dispatch(setresgisterLoading(false));
      dispatch(setRegisterError(error));
    }
  };

//Navivation from Admin login page ("/login")
const loginAsync = (loginData, navigate,decodedRedirectPath) => async (dispatch) => {

  try {
    const response = await authService.login(loginData);
    if (response.error || response.Error) {
      dispatch(setloginError(response.error));
    } else {
      localStorage.setItem("company_id", response?.data?.user?.company_id);
      if (response?.data?.user?.is_participant && response?.participant_data) {
        localStorage.setItem("participant_token", response?.participant_data?.access_token)
        localStorage.setItem("company_id", response?.participant_data?.user?.company_id);
        dispatch(setParticipantLoginData(response?.participant_data));
      }
      localStorage.setItem("authority",response?.data?.user?.authority)
      localStorage.setItem("company_id", response?.data?.user?.company_id);
      localStorage.setItem("admin_token", response?.data?.access_token);
      dispatch(setloginData(response?.data));
      if (response?.data?.user) {
        if (response?.data?.user?.authority === 1 || response?.data?.user?.authority === 4 ) {
          if (decodedRedirectPath)
            navigate(decodedRedirectPath, { replace: true });
          else 
            navigate('/companies',{ replace: true } )
        }
        else if (response?.data?.user?.authority === 2) {
          dispatch(setCompany({
            id: response?.data?.user?.company_id,
            name: response?.data?.user?.company_name,
          }));
          if (decodedRedirectPath)
            navigate(decodedRedirectPath, { replace: true });
          else 
            navigate(`/companies/${response?.data?.user?.company_id}/workshops??tab=0&service=1&page=1&filter=`,{ replace: true })
        }
        else {
          navigate('/login')
        }
      } else {
        navigate('/login')
      }
    }
  } catch (error) {
    dispatch(setloginError(error));
  }
};

//Navivation from participant login page ("participants/login")
const participantLoginAsync = (loginData, navigate, decodedRedirectPath) => async (dispatch) => {

  try {
    const response = await authService.participantLogin(loginData);
    if (response.error || response.Error) {
      dispatch(setParticipantLoginError(response.error));
    } else {
      if ((response?.data?.user?.is_ca || response?.data?.user?.is_secretariat || response?.data?.user?.is_salesperson) && response?.admin_data) {
        localStorage.setItem("admin_token", response?.admin_data?.access_token);
        localStorage.setItem("company_id", response?.admin_data?.user?.company_id);
        localStorage.setItem("authority",response?.admin_data?.user?.authority)
        dispatch(setloginData(response?.admin_data))
      }
      localStorage.setItem("participant_token", response.data.access_token);
      dispatch(setParticipantLoginData(response.data));
      if (response?.data?.user) {
        if (decodedRedirectPath)
          navigate(decodedRedirectPath, { replace: true });
        else
          navigate('/participants/home', { replace: true });
      } else {
        navigate('/participants/login');
      }
    }
  } catch (error) {
    dispatch(setParticipantLoginError(error));
  }
};


export const authAction = {
  adminRegistrationAsync,
  loginAsync,
  participantLoginAsync,
};
